var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48001 9.30035C5.93001 9.92035 7.29001 10.6103 6.64001 11.5103C6.33001 11.9403 5.71001 11.9603 5.34001 11.5903C4.61001 10.7203 3.50001 9.93035 2.81001 9.06035C2.51001 8.68035 2.50001 8.22035 2.83001 7.85035C3.70001 7.12035 4.49001 6.01035 5.36001 5.32035C6.03001 4.79035 6.90001 5.24035 6.78001 6.11035C6.71001 6.61035 5.76001 7.21035 5.48001 7.64035H15.27C20.85 8.35035 20.79 16.2803 15.19 16.8903H5.81001C4.89001 16.7403 4.87001 15.4203 5.77001 15.2303H14.83C17.31 15.1703 18.69 12.2703 17.06 10.3503C16.61 9.82035 15.69 9.30035 14.98 9.30035H5.48001Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.638c4427127af3c05bb2fc29dc705ede.svg";
export { ForwardRef as ReactComponent };